<div class="message-item">
  <div class="author">
    <div class="name-wrapper">
      <img *ngIf="viewModel?.showEredesIcon" src="assets/images/quem-somos.png" alt="E-REDES" />
      <p>{{ viewModel?.author }}</p>
    </div>
    <p class="message-date">{{ viewModel?.date }}</p>
  </div>

  <div>
    <div class="text-message">
      @if (viewModel?.haveLink) {
        @if (viewModel?.type === 'child') {
          <p>
            Foi criado um novo pedido com o ID
            <a
              tabindex="0"
              (click)="clickLink(viewModel?.submitted_form_id)"
              (keydown.enter)="clickLink(viewModel?.submitted_form_id)"
              (keydown.space)="clickLink(viewModel?.submitted_form_id)"
              >{{ viewModel?.external_identification }}</a
            >
            para poder fazer o acompanhamento.
          </p>
        } @else if (viewModel?.type === 'parent') {
          <p>
            Este pedido foi criado no seguimento da reabertura do pedido com o ID
            <a
              tabindex="0"
              (click)="clickLink(viewModel?.submitted_form_id)"
              (keydown.enter)="clickLink(viewModel?.submitted_form_id)"
              (keydown.space)="clickLink(viewModel?.submitted_form_id)"
              >{{ viewModel?.external_identification }}</a
            >
            para poder fazer o acompanhamento.
          </p>
        } @else {
          <p [innerHtml]="viewModel?.message | safeHtml"></p>
        }
      } @else {
        <p [innerText]="viewModel?.message | replaceAll: '\\n' : '\n'"></p>
      }
    </div>

    <div class="attachments-wrapper">
      <app-multi-download-attachment [attachments]="viewModel?.attachments" (clickItem)="clickAttachment($event)">
      </app-multi-download-attachment>
    </div>
  </div>
</div>
